import React from 'react'
import { Delete as DeleteIcon } from '@mui/icons-material'
import { ConfirmDialog } from '@edge/spark/ui'
import { formatWordsFromCamelCase } from '@edge/spark/utils'
import type { CardConfigModalProps } from './types'

export const DeleteConfirmDialog: React.VFC<CardConfigModalProps> = ({
    type,
    open,
    onSuccess,
    onFailure,
    cardTitle,
}: CardConfigModalProps) => (
    <ConfirmDialog
        open={open}
        onSuccess={onSuccess}
        onFailure={onFailure}
        title="Delete"
        successButtonText="OK"
        failureButtonText="Cancel"
        icon={<DeleteIcon />}
        message="Are you sure you want to delete?"
        postMessageEm={cardTitle || formatWordsFromCamelCase(type)}
    />
)

export default DeleteConfirmDialog
